/**
 * Vas Service Management Platform
 * VAS Service Managment Api 
 *
 * OpenAPI spec version: v1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { PartnerRevenueInfo } from '../model/partnerRevenueInfo';
import { ProblemDetails } from '../model/problemDetails';
import { RevenueDetailsDto } from '../model/revenueDetailsDto';
import { RevenueDistributionByServiceDto } from '../model/revenueDistributionByServiceDto';
import { RevenueDistributionByTelcoDto } from '../model/revenueDistributionByTelcoDto';
import { RevenueReportDto } from '../model/revenueReportDto';
import { ServiceAndSubscriberCount } from '../model/serviceAndSubscriberCount';
import { ServiceDistributionCategoryDto } from '../model/serviceDistributionCategoryDto';
import { ServiceDistributionDto } from '../model/serviceDistributionDto';
import { ServiceDistributionTypeDto } from '../model/serviceDistributionTypeDto';
import { ServiceProviderAndRevenue } from '../model/serviceProviderAndRevenue';
import { ServiceProviderServiceAndRevenueListAndCount } from '../model/serviceProviderServiceAndRevenueListAndCount';
import { SubcriberServiceDto } from '../model/subcriberServiceDto';
import { SubscriberCount } from '../model/subscriberCount';
import { SubscriberTelcoDto } from '../model/subscriberTelcoDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class DashboardService {

    protected basePath = 'http://10.1.1.123:30118';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param range 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public dashboardGetAllActiveServiceProviders(range?: number, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public dashboardGetAllActiveServiceProviders(range?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public dashboardGetAllActiveServiceProviders(range?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public dashboardGetAllActiveServiceProviders(range?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (range !== undefined && range !== null) {
            queryParameters = queryParameters.set('range', <any>range);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<number>(`${this.basePath}/api/Dashboard/GetAllActiveServiceProviders`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param creatorId 
     * @param range 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public dashboardGetRevenueForPartners(creatorId?: string, range?: number, observe?: 'body', reportProgress?: boolean): Observable<PartnerRevenueInfo>;
    public dashboardGetRevenueForPartners(creatorId?: string, range?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PartnerRevenueInfo>>;
    public dashboardGetRevenueForPartners(creatorId?: string, range?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PartnerRevenueInfo>>;
    public dashboardGetRevenueForPartners(creatorId?: string, range?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (creatorId !== undefined && creatorId !== null) {
            queryParameters = queryParameters.set('creatorId', <any>creatorId);
        }
        if (range !== undefined && range !== null) {
            queryParameters = queryParameters.set('range', <any>range);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<PartnerRevenueInfo>(`${this.basePath}/api/Dashboard/GetRevenueForPartners`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param creatorId 
     * @param range 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public dashboardGetRevenueReport(creatorId?: string, range?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<RevenueReportDto>>;
    public dashboardGetRevenueReport(creatorId?: string, range?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<RevenueReportDto>>>;
    public dashboardGetRevenueReport(creatorId?: string, range?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<RevenueReportDto>>>;
    public dashboardGetRevenueReport(creatorId?: string, range?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (creatorId !== undefined && creatorId !== null) {
            queryParameters = queryParameters.set('creatorId', <any>creatorId);
        }
        if (range !== undefined && range !== null) {
            queryParameters = queryParameters.set('range', <any>range);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<RevenueReportDto>>(`${this.basePath}/api/Dashboard/GetRevenueReport`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param range 
     * @param skip 
     * @param take 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public dashboardGetServiceAndSubscriberCount(range?: number, skip?: number, take?: number, observe?: 'body', reportProgress?: boolean): Observable<ServiceAndSubscriberCount>;
    public dashboardGetServiceAndSubscriberCount(range?: number, skip?: number, take?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ServiceAndSubscriberCount>>;
    public dashboardGetServiceAndSubscriberCount(range?: number, skip?: number, take?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ServiceAndSubscriberCount>>;
    public dashboardGetServiceAndSubscriberCount(range?: number, skip?: number, take?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (range !== undefined && range !== null) {
            queryParameters = queryParameters.set('range', <any>range);
        }
        if (skip !== undefined && skip !== null) {
            queryParameters = queryParameters.set('skip', <any>skip);
        }
        if (take !== undefined && take !== null) {
            queryParameters = queryParameters.set('take', <any>take);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<ServiceAndSubscriberCount>(`${this.basePath}/api/Dashboard/GetServiceAndSubscriberCount`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param skip 
     * @param take 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public dashboardGetServiceProviderServiceRevenue(skip?: number, take?: number, observe?: 'body', reportProgress?: boolean): Observable<ServiceProviderServiceAndRevenueListAndCount>;
    public dashboardGetServiceProviderServiceRevenue(skip?: number, take?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ServiceProviderServiceAndRevenueListAndCount>>;
    public dashboardGetServiceProviderServiceRevenue(skip?: number, take?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ServiceProviderServiceAndRevenueListAndCount>>;
    public dashboardGetServiceProviderServiceRevenue(skip?: number, take?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (skip !== undefined && skip !== null) {
            queryParameters = queryParameters.set('skip', <any>skip);
        }
        if (take !== undefined && take !== null) {
            queryParameters = queryParameters.set('take', <any>take);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<ServiceProviderServiceAndRevenueListAndCount>(`${this.basePath}/api/Dashboard/GetServiceProviderServiceRevenue`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public dashboardGetTopFiveServiceProvidersAndRevenue(observe?: 'body', reportProgress?: boolean): Observable<Array<ServiceProviderAndRevenue>>;
    public dashboardGetTopFiveServiceProvidersAndRevenue(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ServiceProviderAndRevenue>>>;
    public dashboardGetTopFiveServiceProvidersAndRevenue(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ServiceProviderAndRevenue>>>;
    public dashboardGetTopFiveServiceProvidersAndRevenue(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<ServiceProviderAndRevenue>>(`${this.basePath}/api/Dashboard/GetTopFiveServiceProvidersAndRevenue`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param serviceproviderId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public dashboardGetTotalMonthlyTransactions(serviceproviderId?: string, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public dashboardGetTotalMonthlyTransactions(serviceproviderId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public dashboardGetTotalMonthlyTransactions(serviceproviderId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public dashboardGetTotalMonthlyTransactions(serviceproviderId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (serviceproviderId !== undefined && serviceproviderId !== null) {
            queryParameters = queryParameters.set('serviceproviderId', <any>serviceproviderId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<number>(`${this.basePath}/api/Dashboard/GetTotalMonthlyTransactions`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public dashboardGetTotalRevenueForAdmin(observe?: 'body', reportProgress?: boolean): Observable<number>;
    public dashboardGetTotalRevenueForAdmin(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public dashboardGetTotalRevenueForAdmin(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public dashboardGetTotalRevenueForAdmin(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<number>(`${this.basePath}/api/Dashboard/GetTotalRevenueForAdmin`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param range 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public dashboardGetTotalServicesForAdmin(range?: number, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public dashboardGetTotalServicesForAdmin(range?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public dashboardGetTotalServicesForAdmin(range?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public dashboardGetTotalServicesForAdmin(range?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (range !== undefined && range !== null) {
            queryParameters = queryParameters.set('range', <any>range);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<number>(`${this.basePath}/api/Dashboard/GetTotalServicesForAdmin`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param creatorId 
     * @param range 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public dashboardRevenueDistributionByService(creatorId?: string, range?: number, observe?: 'body', reportProgress?: boolean): Observable<RevenueDistributionByServiceDto>;
    public dashboardRevenueDistributionByService(creatorId?: string, range?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RevenueDistributionByServiceDto>>;
    public dashboardRevenueDistributionByService(creatorId?: string, range?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RevenueDistributionByServiceDto>>;
    public dashboardRevenueDistributionByService(creatorId?: string, range?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (creatorId !== undefined && creatorId !== null) {
            queryParameters = queryParameters.set('creatorId', <any>creatorId);
        }
        if (range !== undefined && range !== null) {
            queryParameters = queryParameters.set('range', <any>range);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<RevenueDistributionByServiceDto>(`${this.basePath}/api/Dashboard/RevenueDistributionByService`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param range 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public dashboardRevenueDistributionByServiceForAdmin(range?: number, observe?: 'body', reportProgress?: boolean): Observable<RevenueDistributionByServiceDto>;
    public dashboardRevenueDistributionByServiceForAdmin(range?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RevenueDistributionByServiceDto>>;
    public dashboardRevenueDistributionByServiceForAdmin(range?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RevenueDistributionByServiceDto>>;
    public dashboardRevenueDistributionByServiceForAdmin(range?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (range !== undefined && range !== null) {
            queryParameters = queryParameters.set('range', <any>range);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<RevenueDistributionByServiceDto>(`${this.basePath}/api/Dashboard/RevenueDistributionByServiceForAdmin`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param creatorId 
     * @param range 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public dashboardRevenueDistributionByTelco(creatorId?: string, range?: number, observe?: 'body', reportProgress?: boolean): Observable<RevenueDistributionByTelcoDto>;
    public dashboardRevenueDistributionByTelco(creatorId?: string, range?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RevenueDistributionByTelcoDto>>;
    public dashboardRevenueDistributionByTelco(creatorId?: string, range?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RevenueDistributionByTelcoDto>>;
    public dashboardRevenueDistributionByTelco(creatorId?: string, range?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (creatorId !== undefined && creatorId !== null) {
            queryParameters = queryParameters.set('creatorId', <any>creatorId);
        }
        if (range !== undefined && range !== null) {
            queryParameters = queryParameters.set('range', <any>range);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<RevenueDistributionByTelcoDto>(`${this.basePath}/api/Dashboard/RevenueDistributionByTelco`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param creatorId 
     * @param range 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public dashboardServiceDistributionByCategory(creatorId?: string, range?: number, observe?: 'body', reportProgress?: boolean): Observable<ServiceDistributionTypeDto>;
    public dashboardServiceDistributionByCategory(creatorId?: string, range?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ServiceDistributionTypeDto>>;
    public dashboardServiceDistributionByCategory(creatorId?: string, range?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ServiceDistributionTypeDto>>;
    public dashboardServiceDistributionByCategory(creatorId?: string, range?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (creatorId !== undefined && creatorId !== null) {
            queryParameters = queryParameters.set('creatorId', <any>creatorId);
        }
        if (range !== undefined && range !== null) {
            queryParameters = queryParameters.set('range', <any>range);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<ServiceDistributionTypeDto>(`${this.basePath}/api/Dashboard/ServiceDistributionByCategory`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param creatorId 
     * @param range 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public dashboardServiceDistributionByTelco(creatorId?: string, range?: number, observe?: 'body', reportProgress?: boolean): Observable<ServiceDistributionDto>;
    public dashboardServiceDistributionByTelco(creatorId?: string, range?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ServiceDistributionDto>>;
    public dashboardServiceDistributionByTelco(creatorId?: string, range?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ServiceDistributionDto>>;
    public dashboardServiceDistributionByTelco(creatorId?: string, range?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (creatorId !== undefined && creatorId !== null) {
            queryParameters = queryParameters.set('creatorId', <any>creatorId);
        }
        if (range !== undefined && range !== null) {
            queryParameters = queryParameters.set('range', <any>range);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<ServiceDistributionDto>(`${this.basePath}/api/Dashboard/ServiceDistributionByTelco`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param creatorId 
     * @param range 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public dashboardServiceDistributionByType(creatorId?: string, range?: number, observe?: 'body', reportProgress?: boolean): Observable<ServiceDistributionCategoryDto>;
    public dashboardServiceDistributionByType(creatorId?: string, range?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ServiceDistributionCategoryDto>>;
    public dashboardServiceDistributionByType(creatorId?: string, range?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ServiceDistributionCategoryDto>>;
    public dashboardServiceDistributionByType(creatorId?: string, range?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (creatorId !== undefined && creatorId !== null) {
            queryParameters = queryParameters.set('creatorId', <any>creatorId);
        }
        if (range !== undefined && range !== null) {
            queryParameters = queryParameters.set('range', <any>range);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<ServiceDistributionCategoryDto>(`${this.basePath}/api/Dashboard/ServiceDistributionByType`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param creatorId 
     * @param range 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public dashboardSubscriberDistriutionByService(creatorId?: string, range?: number, observe?: 'body', reportProgress?: boolean): Observable<SubcriberServiceDto>;
    public dashboardSubscriberDistriutionByService(creatorId?: string, range?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SubcriberServiceDto>>;
    public dashboardSubscriberDistriutionByService(creatorId?: string, range?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SubcriberServiceDto>>;
    public dashboardSubscriberDistriutionByService(creatorId?: string, range?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (creatorId !== undefined && creatorId !== null) {
            queryParameters = queryParameters.set('creatorId', <any>creatorId);
        }
        if (range !== undefined && range !== null) {
            queryParameters = queryParameters.set('range', <any>range);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<SubcriberServiceDto>(`${this.basePath}/api/Dashboard/SubscriberDistriutionByService`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param creatorId 
     * @param range 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public dashboardSubscriberDistriutionByTelco(creatorId?: string, range?: number, observe?: 'body', reportProgress?: boolean): Observable<SubscriberTelcoDto>;
    public dashboardSubscriberDistriutionByTelco(creatorId?: string, range?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SubscriberTelcoDto>>;
    public dashboardSubscriberDistriutionByTelco(creatorId?: string, range?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SubscriberTelcoDto>>;
    public dashboardSubscriberDistriutionByTelco(creatorId?: string, range?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (creatorId !== undefined && creatorId !== null) {
            queryParameters = queryParameters.set('creatorId', <any>creatorId);
        }
        if (range !== undefined && range !== null) {
            queryParameters = queryParameters.set('range', <any>range);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<SubscriberTelcoDto>(`${this.basePath}/api/Dashboard/SubscriberDistriutionByTelco`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param creatorId 
     * @param range 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public dashboardTotalRevenues(creatorId?: string, range?: number, observe?: 'body', reportProgress?: boolean): Observable<RevenueDetailsDto>;
    public dashboardTotalRevenues(creatorId?: string, range?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RevenueDetailsDto>>;
    public dashboardTotalRevenues(creatorId?: string, range?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RevenueDetailsDto>>;
    public dashboardTotalRevenues(creatorId?: string, range?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (creatorId !== undefined && creatorId !== null) {
            queryParameters = queryParameters.set('creatorId', <any>creatorId);
        }
        if (range !== undefined && range !== null) {
            queryParameters = queryParameters.set('range', <any>range);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<RevenueDetailsDto>(`${this.basePath}/api/Dashboard/TotalRevenues`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param creatorId 
     * @param range 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public dashboardTotalServices(creatorId?: string, range?: number, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public dashboardTotalServices(creatorId?: string, range?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public dashboardTotalServices(creatorId?: string, range?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public dashboardTotalServices(creatorId?: string, range?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (creatorId !== undefined && creatorId !== null) {
            queryParameters = queryParameters.set('creatorId', <any>creatorId);
        }
        if (range !== undefined && range !== null) {
            queryParameters = queryParameters.set('range', <any>range);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<number>(`${this.basePath}/api/Dashboard/TotalServices`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param creatorId 
     * @param range 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public dashboardTotalSubscribers(creatorId?: string, range?: number, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public dashboardTotalSubscribers(creatorId?: string, range?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public dashboardTotalSubscribers(creatorId?: string, range?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public dashboardTotalSubscribers(creatorId?: string, range?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (creatorId !== undefined && creatorId !== null) {
            queryParameters = queryParameters.set('creatorId', <any>creatorId);
        }
        if (range !== undefined && range !== null) {
            queryParameters = queryParameters.set('range', <any>range);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<number>(`${this.basePath}/api/Dashboard/TotalSubscribers`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param range 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public dashboardTotalSubscribersForAdmin(range?: number, observe?: 'body', reportProgress?: boolean): Observable<SubscriberCount>;
    public dashboardTotalSubscribersForAdmin(range?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SubscriberCount>>;
    public dashboardTotalSubscribersForAdmin(range?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SubscriberCount>>;
    public dashboardTotalSubscribersForAdmin(range?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (range !== undefined && range !== null) {
            queryParameters = queryParameters.set('range', <any>range);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<SubscriberCount>(`${this.basePath}/api/Dashboard/TotalSubscribersForAdmin`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
